<template>
  <main class="main">
    <div class="content container">
      <MainHeading> Присоединяйтесь к&nbsp;нам! </MainHeading>

      <div class="content__container">
        <p class="content__slogan p-reset">
          Регистрируйтесь. Привлекайте&nbsp;клиентов. Получайте&nbsp;доход.
        </p>

        <form
          class="content__form form"
          action="#"
          @submit.prevent="doRegister()"
        >
          <label class="form__label">
            <span v-if="formError.fullname" class="form__error">{{
              formError.fullname[0]
            }}</span>
            <input
              class="form__input"
              type="text"
              name="name"
              v-model="formData.fullname"
              placeholder="Ваше имя"
            />
          </label>
          <label class="form__label">
            <span v-if="formError.username" class="form__error">{{
              formError.username[0]
            }}</span>
            <input
              class="form__input"
              type="email"
              name="mail"
              v-model="formData.username"
              placeholder="E-mail"
            />
          </label>
          <label class="form__label">
            <span v-if="formError.phone" class="form__error">{{
              formError.phone[0]
            }}</span>
            <input
              class="form__input"
              type="tel"
              name="phone"
              v-model="formData.phone"
              placeholder="Телефон"
            />
          </label>
          <label class="form__label">
            <span v-if="formErrorPassword" class="form__error">{{
              formErrorPassword
            }}</span>
            <input
              class="form__input"
              :type="isPasswordHide ? 'password' : 'text'"
              name="password"
              v-model="formData.password"
              placeholder="Пароль"
            />
            <span
              class="form__label-password-icon"
              @click="isPasswordHide = !isPasswordHide"
            >
              <svg>
                <use
                  :xlink:href="isPasswordHide ? '#icon-show' : '#icon-hide'"
                ></use>
              </svg>
            </span>
          </label>
          <label class="form__label">
            <span v-if="formErrorPasswordRepeat" class="form__error">{{
              formErrorPasswordRepeat
            }}</span>
            <input
              class="form__input"
              :type="isPasswordHide ? 'password' : 'text'"
              name="password"
              v-model="repeatPassword"
              placeholder="Подтверждение пароля"
            />
          </label>
          <label class="form__label">
            <span
              v-if="formError.contact && contactId !== 3"
              class="form__error"
              >{{ formError.contact[0] }}</span
            >
            <span class="form__select-arrow">
              <svg>
                <use xlink:href="#arrow-down"></use>
              </svg>
            </span>
            <select
              v-model.number="currentContactId"
              class="form__select form__input"
              name="contact"
              id=""
            >
              <option value="0" selected>Предпочитаемый способ связи</option>
              <option value="1">WhatsApp</option>
              <option value="2">Telegram</option>
              <option value="3">Другой</option>
            </select>
          </label>

          <label v-if="contactId === 3" class="form__label">
            <span
              v-if="formError.contact && contactId === 3"
              class="form__error"
              >{{ formError.contact[0] }}</span
            >
            <input
              class="form__input"
              type="text"
              name="contact"
              v-model="anotherContact"
              placeholder="Предпочитаемый способ связи"
            />
          </label>

          <label class="form__contract-label">
            <input
              class="form__contract-checkbox"
              type="checkbox"
              @change="doAcceptOffer()"
            />
            <span class="form__contract-marker"></span>
            <span>
              Я подтверждаю своё согласие с условиями
              <a href="/contract-offer.pdf" target="_blank" class="form__contract-link link-reset">договора-оферты</a>
            </span>
          </label>

          <button
            v-show="acceptOffer"
            class="form__submit btn-reset"
            type="submit"
          >
            Стать партнёром
          </button>
          <span class="form__message" v-if="formDataSending">Загрузка...</span>
          <span class="form__message" v-else-if="formDataSendingError">Что-то пошло не так.</span>
          <span class="form__message" v-else-if="formDataSendingSuccess">Успешно!</span>
        </form>
      </div>
    </div>
  </main>
</template>

<style src="@/assets/styles/register-page.css" scoped>
</style>

<script>
import MainHeading from '@/components/MainHeading.vue'
import { API_BASE_URL } from '@/config'

export default {
  components: { MainHeading },
  data () {
    return {
      contactId: 0,
      isPasswordHide: true,
      repeatPassword: '',
      anotherContact: '',
      acceptOffer: false,

      formData: {
        username: '',
        contact: '',
        fullname: '',
        password: '',
        phone: ''
      },
      formError: {},
      formErrorPassword: '',
      formErrorPasswordRepeat: '',

      formDataSending: false,
      formDataSendingError: false,
      formDataSendingSuccess: false
    }
  },
  methods: {
    doAcceptOffer () {
      this.acceptOffer = !this.acceptOffer
    },
    async doRegister () {
      this.formErrorPassword = ''
      this.formErrorPasswordRepeat = ''
      this.formError = {}

      if (!this.formData.password) {
        this.formErrorPassword = 'Придумайте и укажите пароль'
        return
      }
      if (this.formData.password !== this.repeatPassword) {
        this.formErrorPasswordRepeat = 'Указанные пароли не совпадают'
        return
      }

      this.formDataSending = true
      this.formDataSendingError = false
      this.formDataSendingSuccess = false

      const user = {
        ...this.formData,
        contact: this.contactsList[this.contactId]
      }

      try {
        const response = await fetch(
          `${API_BASE_URL}/api/register`,
          {
            method: 'POST',
            body: JSON.stringify(user),
            headers: {
              'Content-Type': 'application/json'
            }
          }
        )

        if (response.status === 201) {
          this.formDataSending = false
          this.formDataSendingSuccess = true
          this.$router.push({ name: 'registerSuccess' })
        } else if (response.status === 422) {
          const error = await response.json()
          this.formDataSending = false
          this.formError = error.errors || {}
          window.scrollTo(scrollY, 100)
        } else {
          this.formDataSending = false
          this.formDataSendingError = true
        }
      } catch (err) {
        this.formDataSending = false
        this.formDataSendingError = true
        throw err
      }
    }
  },
  computed: {
    formErrors () {
      return this.formError
    },
    contactsList () {
      return [
        '',
        'WhatsApp',
        'Telegram',
        this.anotherContact
      ]
    },
    currentContactId: {
      get () {
        return this.contactId ? this.contactId : 0
      },
      set (value) {
        this.contactId = value
      }
    }
  },
  watch: {
    formErrorPasswordRepeat (value) {
      if (value) window.scrollTo(scrollY, 100)
    },
    formErrorPassword (value) {
      if (value) window.scrollTo(scrollY, 100)
    }
  }
}
</script>
